import { withResultContainer } from '@bingads-webui-react/hoc-with-multi-selector-result-container';
import { withDropdownMenu } from '@bingads-webui-react/hoc-with-dropdown-menu';

import { SourceGoalSelector } from './source-goal-selector';

export const SingleGoalSelectorwWthDropdownMenu = withDropdownMenu(SourceGoalSelector);
export const MultiGoalSelectorWthDropdownMenu =
  withDropdownMenu(withResultContainer(SourceGoalSelector));
export const SingleGoalSelector = SourceGoalSelector;
export const MultiGoalSelector =
  withResultContainer(SourceGoalSelector);
